export default "__VITE_ASSET__ced1bd92__"